export enum AssessmentScore {
  Negative = 'Negative',
  Positive = 'Positive',
}

export enum TechnologyPlatform {
  Undefined = 'Undefined',
  Spirit = 'Spirit',
  Neptune = 'Neptune',
  Polaris = 'Polaris',
  Connect = 'Connect',
}

export const TechnologyPlatformNumber = {
  [TechnologyPlatform.Spirit]: 1,
  [TechnologyPlatform.Neptune]: 2,
};

export interface AssessmentScenario {
  achievedCount: number;
  id: string;
  name: string;
  score: number;
  scorePercent: number;
  type: ScenarioType;
}

export enum ScenarioType {
  Achievement = 'Achievement',
  Error = 'Error',
  None = 'None',
}

export type Assessment = {
  criticalAchievement: number;
  criticalError: number;
  limitScore: number;
  name?: string;
  numberOfAchievements: number;
  passed: boolean;
  points: number;
  pointsRange: {
    higher: number;
    lower: number;
  };
  scenarios: AssessmentScenario[];
  score: number;
  scorePercent: number;
  technologyPlatform: TechnologyPlatform;
};

export enum AssessmentResult {
  Passed = 'Passed',
  Failed = 'Failed',
}
